import ACTION from "../action";
import { ApiNames } from "../../api/api";
import { callApi } from "./networkActions";
import { put, takeEvery } from "redux-saga/effects";
import ErrorMessage from "../../component/customComponent/customMessages/ErrorMessage";

function* getEnrollmentsReportDataAction({ filters }) {
  try {
    const exportReportRes = yield callApi(ApiNames.InsightsEnrollmentsReport, filters);

    if (exportReportRes) {
      yield put(ACTION.setEnrollmentsReportData(exportReportRes));
    } else {
      ErrorMessage(`Export failed. Please try again or contact support.`);
    }
  } catch (error) {
    ErrorMessage(`Export failed. Please try again or contact support.`);
  }
}

function* getEnrollmentClaimsReportDataAction({ filters }) {
  try {
    const exportReportRes = yield callApi(ApiNames.InsightsEnrollmentClaims, filters);

    if (exportReportRes) {
      yield put(ACTION.setEnrollmentClaimsReportData(exportReportRes));
    } else {
      ErrorMessage(`Export failed. Please try again or contact support.`);
    }
  } catch (error) {
    ErrorMessage(`Export failed. Please try again or contact support.`);
  }
}

function* getClaimsReportDataAction({ filters }) {
  try {
    const exportReportRes = yield callApi(ApiNames.InsightsClaims, filters);

    if (exportReportRes) {
      yield put(ACTION.setClaimsReportData(exportReportRes));
    } else {
      ErrorMessage(`Export failed. Please try again or contact support.`);
    }
  } catch (error) {
    ErrorMessage(`Export failed. Please try again or contact support.`);
  }
}

function* getOrdersReportDataAction({ filters }) {
  try {
    const exportReportRes = yield callApi(ApiNames.InsightsOrders, filters);

    if (exportReportRes) {
      yield put(ACTION.setOrdersReportData(exportReportRes));
    } else {
      ErrorMessage(`Export failed. Please try again or contact support.`);
    }
  } catch (error) {
    ErrorMessage(`Export failed. Please try again or contact support.`);
  }
}

function* getCompletedOrdersReportDataAction({ filters }) {
  try {
    const exportReportRes = yield callApi(ApiNames.InsightsCompletedOrders, filters);

    if (exportReportRes) {
      yield put(ACTION.setCompletedOrdersReportData(exportReportRes));
    } else {
      ErrorMessage(`Export failed. Please try again or contact support.`);
    }
  } catch (error) {
    ErrorMessage(`Export failed. Please try again or contact support.`);
  }
}

function* actions() {
  yield takeEvery(ACTION.Types.GET_ENROLLMENTS_REPORT_DATA, getEnrollmentsReportDataAction);
  yield takeEvery(ACTION.Types.GET_ENROLLMENT_CLAIMS_REPORT_DATA, getEnrollmentClaimsReportDataAction);
  yield takeEvery(ACTION.Types.GET_CLAIMS_REPORT_DATA, getClaimsReportDataAction);
  yield takeEvery(ACTION.Types.GET_ORDERS_REPORT_DATA, getOrdersReportDataAction);
  yield takeEvery(ACTION.Types.GET_COMPLETED_ORDERS_REPORT_DATA, getCompletedOrdersReportDataAction);
}
export { actions };
